module.exports = __webpack_public_path__ + "images/people/man-woman-employees@1x-0380bf332fdcd114d4e9389b4d928aa7.webp";